<template>
    <div class="content-960 mobile-row" style="margin-top:40px;max-width: 470px; text-align: center;">
        <div class="wrapper-960 clearfix">
            <div class="titles">
                <h2 class="uppercase">
                    <b>Aguarde, estamos concluindo seu acesso.</b><br />
                </h2>
            </div>
            <br />
            <div class="titles icon-animated">
                <i class="fa fa-6x fa-check-circle" style="font-size: 90px;color: green;"></i>
            </div>
        </div>
    </div>
</template>
<script>

    import Auth from '@/common/auth'
    import Global from '@/common/global'
    import Cache from '@/common/cache'
    import { Api } from '@/common/api'

    export default {
        name: 'authorized',
        mounted() {
            Auth.processTokenCallback(() => {

                Auth.getCurrentUser(user => {

                    new Api('colaborador/more', Global.END_POINT_PORTAL_CORPORATIVO).get({
                        filterBehavior: 'GetDataCustom',
                        attributeBehavior: 'DadosColaboradorColaborador',
                        colaboradorId: user.sub,
                        escolaId: user.tenant,
                        chaveIdentificacaoSistema: Global.CHAVE_IDENTIFICACAO_SISTEMA
                    }).then(result => {

                        if (result.data) {
                            Cache.add(Auth.menu_key, result.data.menu)
                            Cache.add(Auth.permissoes_key, result.data.permissoes)
                            Cache.add(Auth.foto_key, result.data.foto)
                            Cache.add(Auth.loadfinished_key, "finished")
                        }
                        else {
                            Auth.login(true);
                            return;
                        }

                        setTimeout(() => {
                            let _lastlocation = Cache.get(Auth.lastlocation_key);
                            if (_lastlocation) window.location = _lastlocation;
                            else window.location = "/";
                        }, 500);
                    })

                });
            });
        }
    }
</script>
